// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import DatePicker from 'react-datepicker';
import FlatButton from 'material-ui/FlatButton';
import AddMatch from '../addTournamentFixture';
import IconButton from 'material-ui/IconButton';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import EditIcon from 'material-ui/svg-icons/image/edit';


class ViewCompetitionMatches extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      competition_id:props.competition_id,
      tournament_id:props.id,
      match_list:[],
      data_uploaded: false,
      data_error: false,
      addExpenseView:false,
      billView:false,
      bill_source:'',
    };
    
    this.getExpenseDetail = this.getExpenseDetail.bind(this);
    
  }

  componentDidMount() {
    this.getExpenseDetail();
    console.log(this.state);
  }

  getExpenseDetail() {
        const url = `${getLocationOrigin()}/tournament/get_competition_matches/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'competition_id': this.state.competition_id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({match_list: data.match_list}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }
  onViewBill(bill_source){
    this.setState({billView:!this.state.billView,bill_source:bill_source})
  }
  


  render() {
    const okaction = <input type="button" className="button1" value="OK" onClick={() => {this.onViewBill()}} /> ;
    console.log(this.state)
    return(
      <div style={{padding:'1%'}}>
        { this.state.match_list && this.state.match_list.length > 0 && 
            <div className="col-md-12" style={styles.table} >
                 <div className="col-md-12" style={styles.sub_header}> List Of Matches </div> 
                <table className="table_plain" >
                          <tr>
                                <th>Date & Time </th>
                                <th>Team One </th>
                                <th>Team Two </th>
                                <th>Match Level </th>
                                <th>Completed </th>
                                <th>Coordinator </th>
                                <th>Action </th>
                          </tr> 
                                        
                      { this.state.match_list.map((match,index) =>
                      <tr key={index}>
                        <td> <div><div>{match.session_start[0]}</div> <div>{match.session_start[1]}</div></div> </td>
                        <td>{match.team_one.name}</td>
                        <td>{match.team_two.name} </td>
                        <td>{match.match_level} </td>
                        <td>{match.is_completed ? "Yes" : "No"}</td>
                        <td>{match.buddy.map((buddy,index) => <div>{buddy.name}</div>)} </td>
                        <td style={{fontSize:'25px'}}><a href={`../../#/crud/editMatch/${match.fixture_id}`} title="Edit" class="x1"><i className="far fa fa-edit" ></i></a>
                        <a href={`../../#/crud/deleteMatch/${match.id}`} title="delete" class="x1">
                            <i className="far fa fa-trash" style={{fontSize:'30px',paddingLeft:'10%'}} />          
                         </a>
                        </td>
                      </tr>
                      )}
                      
                    </table>
            </div>
        }
      </div>
    );
  }
}

export default ViewCompetitionMatches;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetitionMatches/index.js